export * from './feld-entfernt.interface';
